import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import RelativeTime from '@99designs/react-components/components/RelativeTime';
import Icon from '@99designs/react-components/components/Icon';

class HeaderPriceTooltip extends Component {
    constructor(props) {
        super(props);
    }

    getDesignerMessage() {
        const { poolMoney, prizeMoney, hasPoolMoney } = this.props;
        return (
            <div className="contest-tooltip__sub">
                <Icon variations={['trophy-1', 'lighter', 'offset-right']} />
                <div className="contest-tooltip__detail">
                    <div className="contest-tooltip__row">
                        <p className="contest-tooltip__item">
                            <FormattedMessage id="price_tooltip_first_prize" />
                        </p>
                        <p className="contest-tooltip__item contest-tooltip__item--right">
                            {prizeMoney}
                        </p>
                    </div>
                    {hasPoolMoney && (
                        <div className="contest-tooltip__row">
                            <p className="contest-tooltip__item">
                                <FormattedMessage id="price_tooltip_shared_prize" />
                            </p>
                            <p className="contest-tooltip__item contest-tooltip__item--right">
                                {poolMoney}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    getMinimumDesignerLevel() {
        const { minimumDesignerLevel } = this.props;
        if (minimumDesignerLevel === 'entry-level') {
            return <FormattedMessage id="price_tooltip_entry_level" />;
        } else if (minimumDesignerLevel === 'mid-level') {
            return <FormattedMessage id="price_tooltip_mid_level" />;
        } else if (minimumDesignerLevel === 'top-level') {
            return <FormattedMessage id="price_tooltip_top_level" />;
        } else {
            return null;
        }
    }

    render() {
        const { userType, startDate } = this.props;

        const shouldSeePrizeMsg = ['non_entrant_designer', 'entrant_designer', 'admin'].includes(
            userType
        );
        const shouldSeeAdditionalWinnerMsg = ['admin', 'owner'].includes(userType);

        return (
            <div className="contest-tooltip">
                <p className="contest-tooltip__item">
                    <FormattedMessage id="price_category_description" />
                </p>
                <p className="contest-tooltip__item">{this.getMinimumDesignerLevel()}</p>
                <p className="contest-tooltip__item">
                    <span className="subtle-text">
                        <FormattedMessage
                            id="price_tooltip_contest_start_time"
                            values={{ time: <RelativeTime date={startDate} /> }}
                        />
                    </span>
                </p>
                {shouldSeePrizeMsg && this.getDesignerMessage()}
                {shouldSeeAdditionalWinnerMsg && (
                    <div className="contest-tooltip__sub">
                        <Icon variations={['lightbulb-3', 'lighter', 'offset-right']} />
                        <div className="contest-tooltip__row">
                            <p className="contest-tooltip__item contest-tooltip__item--last">
                                <FormattedMessage id="price_tooltip_additional_winner" />
                            </p>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

HeaderPriceTooltip.propTypes = {
    startDate: PropTypes.string.isRequired,
    poolMoney: PropTypes.string.isRequired,
    hasPoolMoney: PropTypes.bool.isRequired,
    prizeMoney: PropTypes.string.isRequired,
    minimumDesignerLevel: PropTypes.string.isRequired,
    userType: PropTypes.oneOf([
        'owner',
        'entrant_designer',
        'non_entrant_designer',
        'admin',
        'other_customer',
        'logged_out',
    ]).isRequired,
};

export default HeaderPriceTooltip;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/header-price-tooltip-card.jsx